import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { MappingService } from "src/core/services/mapping.service";
import { MapDataComponent } from "../../modals/map-data/map-data.component";
import { IssuerMappingService } from "../../../../../api/services/issuer-mapping.service";
import { MappingFilter } from "../../../../../api/models/mapping-filter";
import { MessageService } from "primeng/api";
import { AsReportedIssuer } from "../../../../../api/models/as-reported-issuer";
import {
  handlePasteWithoutLeadingSpaces,
  preventLeadingSpaceKey,
} from "src/core/utils/input-validation.utils";

@Component({
  selector: "app-issuer-unprocessed",
  // imports: [],
  templateUrl: "./unprocessed.component.html",
  styleUrl: "./unprocessed.component.css",
  standalone: false,
})
export class IssuerUnprocessedComponent implements OnChanges {
  @Input() isActive: boolean = false;
  private hasLoadedOnce = false;
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["isActive"]?.currentValue === true) {
      this.hasLoadedOnce = false;
    }
  }
  ref!: DynamicDialogRef;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  unprocessedIssuers: AsReportedIssuer[] = [];
  selectedIssuers: any[] = [];
  selectedDialogRow: any = null;
  first = 0;
  rows = 10;
  issuerName?: string;
  cikNumber?: string;
  isLoading: boolean = false;

  constructor(
    // public mappingService: MappingService,
    private _issuerMappingService: IssuerMappingService,
    public dialogService: DialogService,
    private _messageService: MessageService
  ) {}

  ngOnInit(): void {}
  getUnprocessedIssuers() {
    const params: MappingFilter = {
      searchByName: this.issuerName,
      searchByCikNumber: this.cikNumber,
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      status: "UNPROCESSED",
    };
    this.isLoading = true;
    this._issuerMappingService.getIssuerMapping(params).subscribe({
      next: (value) => {
        this.unprocessedIssuers = value.UnprocessedIssuer ?? [];
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.unprocessedIssuers?.[0]?.totalCount ?? 0;
        this.isLoading = false;
      },
    });
  }
  onSearch() {
    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getUnprocessedIssuers();
  }
  openMapModal(product?: any, event?: Event) {
    if (event) event.preventDefault();
    this.ref = this.dialogService.open(MapDataComponent, {
      dismissableMask: false,
      closable: true,
      modal: true,
      showHeader: true,
      style: { width: "60vw" },
      contentStyle: { overflow: "auto" },
      header: "Mapping",
      data: {
        issuers:
          this.selectedIssuers.length > 0 ? this.selectedIssuers : [product],
      },
    });
    this.ref.onClose.subscribe((refresh) => {
      if (refresh) {
        this.getUnprocessedIssuers();
        this.selectedIssuers = [];
      }
    });
  }

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }
  onGroupMapClick() {
    if (this.selectedIssuers.length > 0) {
      this.openMapModal();
    }
  }

  loadData(event: any) {
    if (!this.isActive) return;
    if (!this.hasLoadedOnce && event.first === 0) {
      this.hasLoadedOnce = true;
    } else if (!this.hasLoadedOnce) {
      return;
    }

    if (event.first > 0 && this.paginator.pageSize !== event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }

    this.paginator.pageSize = event.rows;
    this.getUnprocessedIssuers();
  }
  preventSpaceKey(event: KeyboardEvent): void {
    preventLeadingSpaceKey(event);
  }

  onPaste(event: ClipboardEvent, field: "issuerName" | "cikNumber"): void {
    handlePasteWithoutLeadingSpaces(event, (newValue: string) => {
      this[field] = newValue;
    });
  }
}
